import { Fragment } from 'react/jsx-runtime';
import { formatValueAsString } from '../../../../utils/helpers';
import { TSubscribedMsiVessel } from '../../../../user-management/subscription/subscriptionTypes';
import { useAppSelector } from '../../../../core/rootHooks';
import { selectIsMsi } from '../../../../user-management/appSelectors';
import OwnerRenderer from '../../../../shared/components/renderers/OwnerRenderer';

export const VesselInfo = ({ vesselData }: { vesselData: TSubscribedMsiVessel }) => {
	const isMsi = useAppSelector(selectIsMsi);

	const infoItems = [
		['Name', vesselData.vesselName],
		['IMO Number', vesselData.imoNumber],
		['Sector', vesselData.sectorName],
		['Size/Capacity', formatValueAsString(vesselData.size)],
		['Year of Delivery', vesselData.yearOfDelivery],
		['Ice Class', vesselData.iceClass],
		['Country of Build', vesselData.countryOfBuild],
		['Yard Tier', vesselData.yardTier],
		['Gear', vesselData.gear],
		['Hatch', vesselData.hatch],
		['Scrubber-Fitted', vesselData.scrubberFitted],
		['Fuel System', vesselData.fuelSystem],
		['Owner', <OwnerRenderer ownerName={vesselData.owner} className='text-xs'/>],
		['Reported ETA', vesselData.reportedEta && new Date(vesselData.reportedEta).toLocaleString()],
		['Reported Destination', vesselData.reportedDestination],
	];

	if (isMsi) {
		infoItems.push(['Engine kW', formatValueAsString(vesselData.engine)]);
		infoItems.push(['Speed', formatValueAsString(vesselData.speed)]);
	}

	return (
		<div id="vesselInfo" className="grid grid-cols-2 gap-y-1 pt-3 text-xs">
			{infoItems.map(
				([label, value], index) =>
					value && (
						<Fragment key={index}>
							<span className="font-bold text-msi-midblue-color-500 text-right pr-2">{label!.toString()}:</span>
							<span>{value}</span>
						</Fragment>
					),
			)}
		</div>
	);
};
